import React, { Component } from 'react'
import MyNewCase from "./my-support-new-case"
import MyCaseList from './my-support-case-list'
import MyCase from './my-support-case'
import * as support from '../../api/support'
import FourOhFour from './404'
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

export default class MySupport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            UserID: this.props.UserID,
            EnvSettings: null,
            InEU: this.props.InEU || null
        }
    }

    async componentDidMount() {
        this.setState({ Loading: true });
        await this.getEnironmentSettings();
        this.setState({ Loading: false });

    }

    getEnironmentSettings = async () => {
        let _settings = await support.GetCaseSettings();
        console.log(_settings);
        this.setState({
            EnvSettings: _settings
        })
    }
    
    render() {

        return (
            
            <Router basename={`/my-account/my-support`}>
                <Switch>
                    <Route exact path="/"  >
                        <MyCaseList UserID={this.state.UserID} EnvSettings={this.state.EnvSettings}  InEU={this.state.InEU}/>
                    </Route>
                    <Route exact path="/case/:caseid" >
                        <MyCase UserID={this.state.UserID} EnvSettings={this.state.EnvSettings} InEU={this.state.InEU} />
                    </Route>
                    <Route path="/newcase"  >
                        <MyNewCase InEU={this.state.InEU}  />
                    </Route>
                    <Route path={`/*`} component={FourOhFour}>
                    </Route>
                </Switch>
            </Router>
           
        )
    }

}

